<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 51.176 21.405">
    <g id="SUV" transform="translate(0 0)">
      <path id="Path_86906" data-name="Path 86906"
        d="M2076.7,321.353a4.588,4.588,0,1,0-4.587-4.588,4.593,4.593,0,0,0,4.587,4.588m0-7.448a2.86,2.86,0,1,1-2.859,2.86,2.864,2.864,0,0,1,2.859-2.86"
        transform="translate(-2034.6 -299.947)" :fill="themeColor" />
      <path id="Path_86907" data-name="Path 86907"
        d="M2285.524,321.353a4.588,4.588,0,1,0-4.588-4.588,4.593,4.593,0,0,0,4.588,4.588m0-7.448a2.86,2.86,0,1,1-2.86,2.86,2.863,2.863,0,0,1,2.86-2.86"
        transform="translate(-2274.559 -299.947)" :fill="themeColor" />
      <path id="Path_86908" data-name="Path 86908"
        d="M2044.3,247.968h2.2a.864.864,0,0,0,0-1.728h-2.032c-.356-.54-.716-2.767-.737-5.532l.765-1.177a.863.863,0,0,0,.123-.3c.681-3.416,1.916-6.763,2.592-7.025,1.291-.17,20.492-.742,24.19.256,1.26.34,2.837,1.831,4.228,3.146a13.153,13.153,0,0,0,3.057,2.439,18.9,18.9,0,0,0,5.13.624c2.15.108,5.094.255,5.812.76.442.424,1.24,3.254,1.751,5.8l-1.246,1.274a.864.864,0,0,0,1.235,1.208l1.563-1.6a.864.864,0,0,0,.231-.766c-.455-2.389-1.388-6.517-2.541-7.328-1.048-.737-3.341-.9-6.719-1.072a21.006,21.006,0,0,1-4.521-.48,13.223,13.223,0,0,1-2.565-2.113c-1.54-1.455-3.284-3.1-4.964-3.558-4.127-1.114-23.549-.474-24.892-.3-2.076.278-3.388,5.2-4,8.231l-.816,1.254a.866.866,0,0,0-.14.471c0,7.514,1.729,7.514,2.3,7.514"
        transform="translate(-2042.005 -230.152)" :fill="themeColor" />
      <path id="Path_86909" data-name="Path 86909"
        d="M2141.736,339.786h18.011a.864.864,0,0,0,0-1.728h-18.011a.864.864,0,1,0,0,1.728"
        transform="translate(-2124.177 -321.97)" :fill="themeColor" />
      <path id="Path_86910" data-name="Path 86910"
        d="M2115.677,260.658h29.61a.864.864,0,0,0,0-1.728h-29.231l-2.348-2.549a.864.864,0,1,0-1.27,1.17l2.6,2.828a.864.864,0,0,0,.635.279"
        transform="translate(-2105.442 -252.234)" :fill="themeColor" />
      <path id="Path_86911" data-name="Path 86911"
        d="M2345,234.218a.749.749,0,0,0,.076,0l2.456-.215a.864.864,0,0,0-.15-1.721l-2.456.215a.864.864,0,0,0,.074,1.724"
        transform="translate(-2342.195 -231.957)" :fill="themeColor" />
    </g>
  </svg>
</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
